angular.module('logbook').directive('limitKeyEntryToMax', [function() {
	return {
		restrict: 'A',
		link: function(scope, element, attributes) {
			element.on('keyup', function(e) {
				if (![46, 8].includes(e.keyCode) &&
					Number(element.val()) > Number(attributes.max)) {
					e.preventDefault();

					element.val(attributes.max);
				}
			});
		}
	};
}]);